import { cn } from '@/lib/cn';

export function AppLogo({ compact = false, className }: { compact?: boolean; className?: string }) {
  return (
    <div className={cn('inline-flex items-center gap-3', className)}>
      <svg aria-hidden="true" className="size-9 shrink-0" viewBox="0 0 64 64">
        <rect width="64" height="64" rx="16" className="fill-ink" />
        <path
          d="M18 15h13c12 0 20 6.7 20 17s-8 17-20 17H18V15Z"
          fill="none"
          className="stroke-accent"
          strokeWidth="7"
        />
        <path
          d="m25 33 5.5 5.5L41 27"
          fill="none"
          className="stroke-canvas"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="5"
        />
      </svg>
      {!compact ? (
        <span className="font-display text-sm font-extrabold tracking-[0.2em] text-ink">
          DISCIPLINE
        </span>
      ) : null}
    </div>
  );
}
